<template>
  <div class="app-header">
    <hamburger-navigation-header v-if="isHomePage"/>
    <back-navigation-header v-else :on-back="redirectBackToHomePage"/>
    <general-error v-if="errorType"></general-error>
    <template v-else>
      <div v-show="appLoading" class="loader-container">
        <loader></loader>
      </div>

      <router-view v-show="!appLoading"/>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import HamburgerNavigationHeader from './HamburgerNavigationHeader.vue';
import BackNavigationHeader from './BackNavigationHeader.vue';
import Loader from '../Loader.vue';
import GeneralError from '../../pages/general-errors/GeneralError.vue';
import router from '../../router';

const HOME = 'home';
const CASHFLOW_APP = 'cashflow-app';

export default {
  name: 'AppHeader',
  beforeRouteUpdate(to, from, next) {
    this.resetError();
    next();
  },
  data() {
    return {
      isHomePage: false,
    };
  },
  components: {
    HamburgerNavigationHeader,
    BackNavigationHeader,
    Loader,
    GeneralError,
  },
  created() {
    this.isHomePage = this.isHomePageRoute(this.$router.currentRoute);
  },
  methods: {
    ...mapActions('genericError', ['resetError']),
    redirectBackToHomePage() {
      router.push({ path: `/${HOME}`, query: this.$route.query });
    },
    isHomePageRoute(route) {
      return _.includes(route.path, CASHFLOW_APP) || _.includes(route.path, HOME);
    },
  },
  computed: {
    ...mapGetters('loader', ['appLoading']),
    ...mapState('genericError', ['errorType']),
  },
  watch: {
    $route(to, from) {
      this.isHomePage = this.isHomePageRoute(to);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../scss/global-variables';

  .app-header {
  }
</style>
